import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _commonCustomValue = {
    numValue: 'DOUBLE',
    dateValue: 'google.protobuf.Timestamp',
    listValue: '_commonListValue',
    mapValue: '_commonMapValue',
};
var _commonListValue = { value: '_commonCustomValue' };
var _commonMapValue = { value: 'Map#_commonCustomValue' };
var _customField = { value: '_customValue' };
var _customValue = {
    numValue: 'DOUBLE',
    dateValue: 'google.protobuf.Timestamp',
    listValue: '_listValue',
    mapValue: '_mapValue',
};
var _identity = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    identityProfile: '_identityProfile',
};
var _identityProfile = { customFields: '_customField' };
var _listValue = { value: '_customValue' };
var _mapValue = { value: 'Map#_customValue' };
var _resendDuringAuthenticationRequest = {};
var _startRequest = {};
var _startResponse = {};
var _stateMachineResponse = {
    identity: '_identity',
    additionalData: 'Map#_commonCustomValue',
};
var _verifyDuringAuthenticationRequest = {};
var _verifyRequest = {};
var _verifyResponse = {};
function resolveWixIamVerificationV1VerificationServiceUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/_api/iam/verification',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/iam/verification',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/iam/verification',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * starts a verification process
 * example: sends a code to the identity's email
 */
export function start(payload) {
    var _a = serializer(_startRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_startResponse, {}).fromJSON;
    function __start(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.verification.v1.start_response',
            method: 'POST',
            methodFqn: 'wix.iam.verification.v1.VerificationService.Start',
            url: resolveWixIamVerificationV1VerificationServiceUrl({
                protoPath: '/v1/Start',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __start.fromReq = fromReq;
    __start.__isAmbassador = true;
    return __start;
}
/**
 * verifies the code in the request.
 * the identity is taken from identity response
 * exposure is private until we need to implement it
 */
export function verify(payload) {
    var _a = serializer(_verifyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_verifyResponse, {}).fromJSON;
    function __verify(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.verification.v1.start_response',
            method: 'POST',
            methodFqn: 'wix.iam.verification.v1.VerificationService.Verify',
            url: resolveWixIamVerificationV1VerificationServiceUrl({
                protoPath: '/v1/verify',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __verify.fromReq = fromReq;
    __verify.__isAmbassador = true;
    return __verify;
}
/**
 * Continues the registration process when a member is required to verify an email address
 * using a verification code received by email.
 *
 * Email verification is required when the registering member is already listed as a contact.
 *
 * Typically, after a successful verification, you generate and use member tokens for the
 * registered member so that subsequent API calls are called as part of a member session.
 */
export function verifyDuringAuthentication(payload) {
    var _a = serializer(_verifyDuringAuthenticationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_stateMachineResponse, {
        _commonCustomValue: _commonCustomValue,
        _commonListValue: _commonListValue,
        _commonMapValue: _commonMapValue,
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __verifyDuringAuthentication(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.verification.v1.start_response',
            method: 'POST',
            methodFqn: 'wix.iam.verification.v1.VerificationService.VerifyDuringAuthentication',
            url: resolveWixIamVerificationV1VerificationServiceUrl({
                protoPath: '/v1/auth/verify',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __verifyDuringAuthentication.fromReq = fromReq;
    __verifyDuringAuthentication.__isAmbassador = true;
    return __verifyDuringAuthentication;
}
/**
 * Resend the verification email and continue the registration process when a member is required to verify an email address
 * using a verification code received by email.
 */
export function resendDuringAuthentication(payload) {
    var _a = serializer(_resendDuringAuthenticationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_stateMachineResponse, {
        _commonCustomValue: _commonCustomValue,
        _commonListValue: _commonListValue,
        _commonMapValue: _commonMapValue,
        _customField: _customField,
        _customValue: _customValue,
        _identity: _identity,
        _identityProfile: _identityProfile,
        _listValue: _listValue,
        _mapValue: _mapValue,
    }).fromJSON;
    function __resendDuringAuthentication(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.iam.verification.v1.start_response',
            method: 'POST',
            methodFqn: 'wix.iam.verification.v1.VerificationService.ResendDuringAuthentication',
            url: resolveWixIamVerificationV1VerificationServiceUrl({
                protoPath: '/v1/auth/resend',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resendDuringAuthentication.fromReq = fromReq;
    __resendDuringAuthentication.__isAmbassador = true;
    return __resendDuringAuthentication;
}
//# sourceMappingURL=http.impl.js.map